<template>
  <span>
    <v-menu offset-y top>
      <template v-slot:activator="{ on: menu }">
        <v-tooltip v-if="Boolean(assignment.lastNotificationSentAt)" bottom>
          <template v-slot:activator="{ on: tooltip }">
            <span v-on="{ ...tooltip, ...menu }">
              <v-btn x-small text><v-icon small>mdi-email-check</v-icon></v-btn>
            </span>
          </template>
          <span
            >Emailed on {{ assignment.formattedLastNotificationSentAt }}
          </span>
        </v-tooltip>
        <v-tooltip v-else bottom>
          <template v-slot:activator="{ on: tooltip }">
            <span v-on="{ ...tooltip, ...menu }">
              <v-btn x-small text><v-icon small>mdi-email</v-icon></v-btn>
            </span>
          </template>
          <span>Email Provider </span>
        </v-tooltip>
      </template>
      <v-list dense nav>
        <template v-for="type in notificationTypes">
          <v-list-item :key="type" @click="sendNotification(type)"
            >{{ type }}
          </v-list-item>
        </template>
      </v-list>
    </v-menu>
    <confirm-modal ref="confirm"></confirm-modal>
  </span>
</template>

<script>
import ConfirmModal from "../../Shared/confirm-modal";

export default {
  props: ["assignment"],
  components: {
    ConfirmModal,
  },
  computed: {
    notificationTypes() {
      return [
        "New Case Assignment",
        "Annual Review With Change",
        "Annual Review No Change",
        "Annual Review RS Change",
      ];
    },
  },
  methods: {
    async sendNotification(type) {
      if (
        await this.$refs.confirm.open(
          `Send '${type}' Email to Provider?`,
          "",
          "Send"
        )
      ) {
        this.$store.commit("uxModule/setShowLoader", true);
        let message = await this.$store.dispatch(
          "plansModule/sendAssignmentNotification",
          {
            assignmentId: this.assignment.assignmentId,
            notificationType: type,
          }
        );
        this.$store.commit("uxModule/setShowLoader", false);

        if (message) {
          this.$store.commit("uxModule/setSnackbarMsg", message);
          this.$store.commit("uxModule/setShowSnackbar", true);
        }
      }
    },
  },
};
</script>
